var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    {
      staticClass: "scroll-y",
      class: { "no-padding": _vm.invoices.length !== 0 },
      attrs: { name: "invoices" }
    },
    [
      _vm.invoices.length
        ? _c(
            "div",
            {
              staticClass:
                "row justify-between border-bottom customer-card__stats"
            },
            [
              _c("div", { staticClass: "col row justify-center" }, [
                _c("div", [
                  _c("h4", { staticClass: "text-weight-thin no-margin" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatMoney(
                          _vm.totalRevenue,
                          _vm.totalRevenueCurrency,
                          0,
                          0
                        )
                      )
                    )
                  ]),
                  _c("span", { staticClass: "text-faded text-weight-light" }, [
                    _vm._v(_vm._s(_vm.$t("statistics_revenue")))
                  ])
                ])
              ]),
              _c("div", { staticClass: "col row justify-center" }, [
                _c("div", [
                  _c("h4", { staticClass: "text-weight-thin no-margin" }, [
                    _vm._v(_vm._s(_vm.totalInvoiceCount))
                  ]),
                  _c("span", { staticClass: "text-faded text-weight-light" }, [
                    _vm._v(_vm._s(_vm.$tc("invoice", _vm.totalInvoiceCount)))
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _c("div", [
        !_vm.isSupplier && _vm.invoices.length
          ? _c(
              "div",
              {
                directives: [{ name: "is-user", rawName: "v-is-user" }],
                staticClass:
                  "row sticky-top bg-white q-px-md q-py-sm border-bottom customer-card__toolbar"
              },
              [
                _c("q-btn", {
                  attrs: {
                    flat: "",
                    icon: "add",
                    label: _vm.$tc("invoice", 1)
                  },
                  on: { click: _vm.handleCreateInvoice }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "text-select" },
          [
            _vm.invoices.length
              ? _c("invoice-table", {
                  staticClass: "no-shadow",
                  attrs: {
                    invoices: _vm.invoices,
                    mapFunctionOverride: _vm.mapFunction,
                    columnsOverride: _vm.columns
                  }
                })
              : [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-center items-center col-grow q-pt-lg"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("img", {
                            attrs: {
                              src: require("assets/emptystates/invoices_empty.svg"),
                              height: "100px"
                            }
                          }),
                          _c("h6", { staticClass: "q-my-md text-faded" }, [
                            _vm._v(_vm._s(_vm.$t("invoices_empty")))
                          ]),
                          !_vm.isSupplier
                            ? _c(
                                "q-btn",
                                {
                                  directives: [
                                    { name: "is-user", rawName: "v-is-user" }
                                  ],
                                  staticClass: "q-mt-lg",
                                  attrs: { color: "primary", outline: "" },
                                  on: { click: _vm.handleCreateInvoice }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("create_invoice")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }